/**
 * Get the sign up context for registration based on URL parameters
 * @return {String}
 */

export const getRegistrationSignUpContext = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const utmMediums = searchParams.getAll('utm_medium') || [];

  let signUpContext = 'New Account';
  // If coming from Fandom Journey campaign, set context to 'fandomuser' which will trigger specific welcome emails
  if (utmMediums && utmMediums.includes('email_novsuperlatives')) signUpContext = 'fandomuser';

  return signUpContext;
};

export default getRegistrationSignUpContext;
